module.exports = __webpack_public_path__ + "files/85454d5ea259cf61ec393241d1bf0ae9.png";